import { Fragment } from "react";
import { useSelector } from "react-redux";
import Loader from "../views/common/loader";
export default function LoaderWrapper({ history, children }) {
  let {
    pasaStore: { loading }
  } = useSelector((state) => state);
  return (
    <Fragment>
      {loading && <Loader />}
      {children}
    </Fragment>
  );
}
